import { render } from "./MergeFiles.vue?vue&type=template&id=5314ece6&scoped=true"
import script from "./MergeFiles.vue?vue&type=script&lang=js"
export * from "./MergeFiles.vue?vue&type=script&lang=js"

import "./MergeFiles.vue?vue&type=style&index=0&id=5314ece6&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5314ece6"]])

export default __exports__